import { StateCreator } from 'zustand';

export interface UploadPhotoSlice {
  imageUrl: string | ArrayBuffer | null;
  selectedImage: File[] | undefined;
  blobEndpoint: string;
  blobUri: string;
  classification: string;
  latitude: number;
  longitude: number;
  formattedInferCategory: string | undefined;
  filename: string;
  updateImageUrl: (imageUrl: string | ArrayBuffer | null) => void;
  updateSelectedImage: (selectedImage: File[] | undefined) => void;
  updateBlobEndpoint: (blobImage: string) => void;
  updateBlobUri: (blobUri: string | undefined) => void;
  updateClassification: (classification: string) => void;
  updateLatitude: (latitude: number) => void;
  updateLongitude: (latitude: number) => void;
  updateFormattedInferCategory: (
    formattedInferCategory: string | undefined,
  ) => void;
  updateFilename: (filename: string) => void;
  resetAllUploadPhoto: () => void;
}

export const createUploadPhotoSlice: StateCreator<
  UploadPhotoSlice,
  [],
  [],
  UploadPhotoSlice
> = (set) => ({
  imageUrl: '',
  selectedImage: undefined,
  blobUri: '',
  blobEndpoint: '',
  classification: '',
  latitude: 0,
  longitude: 0,
  formattedInferCategory: '',
  filename: '',
  updateFilename: (filename) => set(() => ({ filename })),
  updateImageUrl: (imageUrl) => set(() => ({ imageUrl })),
  updateSelectedImage: (selectedImage) => set(() => ({ selectedImage })),
  updateBlobUri: (blobUri) => set(() => ({ blobUri })),
  updateBlobEndpoint: (blobEndpoint) => set(() => ({ blobEndpoint })),
  updateClassification: (classification) => set(() => ({ classification })),
  updateLatitude: (latitude) => set(() => ({ latitude })),
  updateLongitude: (longitude) => set(() => ({ longitude })),
  updateFormattedInferCategory: (formattedInferCategory) =>
    set(() => ({ formattedInferCategory })),
  resetAllUploadPhoto: () => {
    sessionStorage.removeItem('selectedFile');
    set(() => ({
      imageUrl: '',
      selectedImage: undefined,
      blobUri: '',
      blobEndpoint: '',
      classification: '',
      latitude: 0,
      longitude: 0,
      filename: '',
      formattedInferCategory: '',
    }));
  },
});
